module.exports = __webpack_public_path__ + "img/chaos_section_bg_sm.beb75637.png";